import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorToolbarModule } from '@portal-core/ui/editor/components/editor-toolbar/editor-toolbar.module';
import { CodeEditorToolbarComponent } from './code-editor-toolbar.component';

@NgModule({
  declarations: [
    CodeEditorToolbarComponent
  ],
  imports: [
    CommonModule,
    EditorToolbarModule
  ],
  exports: [
    CodeEditorToolbarComponent
  ]
})
export class CodeEditorToolbarModule { }
